import { useAdminApi } from "../../common/api/admin-api/useAdminApi";
import { useDeliveryApi } from "../../common/api/delivery-api/useDeliveryApi";

export const useAdminUsersApi = () => {
    const { getUsersList } = useAdminApi();
    const { getOriginatorsLookup } = useDeliveryApi();

    return {
        getUsersList,
        getOriginatorsLookup
    };
};
